<template>
  <div class="mt-2">
    <div v-if="loading">
      <v-skeleton-loader
        class="mx-auto"
        type="list-item, list-item-three-line, list-item-three-line, list-item-three-line,list-item,  list-item-three-line"
      ></v-skeleton-loader>
    </div>
    <div v-else-if="data">
      <v-list dense shaped color="transparent">
        <v-list-item-group color="primary" dense class="mb-4" v-model="selected"
          ><v-subheader><div class="ml-2">Billing Protocols</div></v-subheader>
          <v-list-item
            dense
            v-for="item in data"
            :key="item.slug"
            :value="item.slug"
            @click="setDetail(item.slug)"
          >
            <v-list-item-content dense>
              <v-list-item-title dense>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            dense
            @click="setDetail('protocols-disclaimer')"
            value="protocols-disclaimer"
          >
            <v-list-item-content dense>
              <v-list-item-title dense><i>Disclaimer</i></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <coding-see-also currentKey="billing-protocols"></coding-see-also>
    </div>
  </div>
</template>

<script>
import ApiServices from "@/services/ApiServices";
// import CurrentModuleMixin from "@/assets/js/CurrentModuleMixin";
// import UserMixin from "@/assets/js/UserMixin";
import CodingSeeAlso from "@/components/icdStuff/CodingSeeAlso.vue";

export default {
  name: "BillingProtocolsMenuBtns",
  components: {
    CodingSeeAlso,
  },
  mixins: [
    // CurrentModuleMixin,
    // UserMixin,
  ],
  props: {},
  data: function () {
    return {
      loading: true,
      data: null,
      selected: "armd-protocols",
      //   iconSrc: "https://www.eyedock.com/images/menu_icons/",
    };
  },
  methods: {
    callApi() {
      this.loading = true;
      ApiServices.genericApiCall("/references/protocols/menuOptions")
        .then((response) => {
          this.data = response.data;
        })
        .catch((error) => {
          console.log("error", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setDetail(detail) {
      this.$store.dispatch("setModeAndDetail", {
        mode: null,
        detail: detail,
      });
    },
    setSelected(detail) {
      this.selected = detail;
    },
  },
  computed: {
    storedItem: function () {
      return this.$store.state.detail;
    },
  },
  watch: {
    storedItem(val) {
      this.setSelected(val);
    },
  },
  mounted() {
    if (this.storedItem) this.setSelected(this.storedItem);
    this.callApi();
  },
};
</script>

<style scoped></style>
